import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { splitIdentifierLabel } from "../../../lib/app-ui/object-record/utils/split-identifier-label";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const investmentsIdentity = defineEntityIdentity({
	definitionKey: "investments",
	pageKey: "investments",
	nameSingular: "investment",
	namePlural: "investments",
	relationKey: "investment",
	auditKey: "investments",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.investments.readAll, audience: "allMembers" },
		create: { ...PERMISSIONS.investments.createAll, audience: "restricted" },
		update: { ...PERMISSIONS.investments.updateAll, audience: "restricted" },
		delete: { ...PERMISSIONS.investments.deleteAll, audience: "restricted" }
	}
});

export const valuationsIdentity = defineEntityIdentity({
	definitionKey: null,
	pageKey: "valuations",
	nameSingular: "valuation",
	namePlural: "valuations",
	relationKey: "valuation",
	auditKey: "valuations",
	storage: "durable",
	actions: {
		create: PERMISSIONS.investments.createAll,
		update: PERMISSIONS.investments.updateAll,
		delete: PERMISSIONS.investments.deleteAll
	}
});

export const estimatedNetProceedsIdentity = defineEntityIdentity({
	definitionKey: null,
	pageKey: "estimatedNetProceeds",
	nameSingular: "estimatedNetProceeds",
	namePlural: "estimatedNetProceedsRows",
	relationKey: null,
	auditKey: "estimated_net_proceeds",
	storage: "durable",
	actions: {
		delete: PERMISSIONS.system.createAll
	}
});

export const costEntriesPanelIdentity = defineEntityIdentity({
	definitionKey: null,
	pageKey: "costEntriesPanel",
	nameSingular: "costEntriesPanel",
	namePlural: "costEntriesPanels",
	relationKey: null,
	auditKey: null,
	storage: "synthetic"
});

export function displayPrefix(r: Record<string, unknown>): string {
	const seq = r.sequenceNumber as number | null | undefined;
	const created = r.createdAt as string | undefined;
	if (seq == null || !created) {
		const dn = r.displayName;
		return typeof dn === "string" ? (splitIdentifierLabel(dn).code ?? "") : "";
	}
	const tract = r.tractIndex as number | null | undefined;
	const base = `#${new Date(created).getUTCFullYear()}-${seq}`;
	return tract != null ? `${base}-${String(tract).padStart(2, "0")}` : base;
}
